module.exports = [{
      plugin: require('/Users/w4aadeyemo/Projects/lets-go-tours-booked-offers/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"kpm8the"}},
    },{
      plugin: require('/Users/w4aadeyemo/Projects/lets-go-tours-booked-offers/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
